/**
 * Handle Animation
 */
const handleVideoAnimation = () => {
	const $container = $('.js-video-animations');

	if (! $container.length > 0) {
		return;
	}

	startAnimation();
}

/**
 * Start Animation
 */
const startAnimation = () => {
	const $container = $('.js-video-animations');

	$container.on('update:visible-logo-and-field', function() {
		setTimeout(function() {
			activeFocusState();
		}, 1500);
	}).on('update:actived-focus-state', function() {
		setTimeout(function() {
			insertTextAnimation($container.find('.video-animation__letters .video-animation__letter').first());
		}, 500);
	}).on('update:text-insert', function() {
		setTimeout(function() {
			removeFocusState();
		}, 1000);
	}).on('update:remove-focus-state', function() {
		convertToRectangle($container.find('.video-animation'))
	}).on('update:covert-to-rectangle', function() {
		setTimeout(function() {
			convertToCircle($container.find('.video-animation'))
		}, 1500);
	}).on('update:covert-to-circle', function() {
		setTimeout(function() {
			convertToSquare($container.find('.video-animation'))
			hideLogoAndField();
		}, 3000);
	}).on('update:covert-to-square', function() {
		setTimeout(function() {
			resetAnimation();
		}, 1000);
	});

	visibleLogoAndField();
}

/**
 * Add active class on elements in animation
 */
const visibleLogoAndField = () => {
	const $container = $('.js-video-animations');

	$container.find('.video-animation__logo')
		.addClass('is-active');

	$container.find('.video-animation__field')
		.addClass('is-active');

	$container.trigger('update:visible-logo-and-field');
}

/**
 * Remove active class on elements in animation
 */
const hideLogoAndField = () => {
	const $container = $('.js-video-animations');

	$container.find('.video-animation__logo')
		.removeClass('is-active');

	$container.find('.video-animation__field')
			.removeClass('is-active');

	setTimeout(function() {
		$container.find('.video-animation__letter')
			.removeClass('video-animation__letter--added');
	}, 900);
}

/**
 * Add focus state on field in animation
 * @return {[type]} [description]
 */
const activeFocusState = () => {
	const $container = $('.js-video-animations');

	$container.find('.video-animation__control')
		.addClass('video-animation__control--focus');

	$container.find('.video-animation__control')
		.addClass('video-animation__control--cursor-blinking');

	$container.trigger('update:actived-focus-state');
}

/**
 * Remove focus state on filed in animation
 * @return {[type]} [description]
 */
const removeFocusState = () => {
	const $container = $('.js-video-animations');

	$container.find('.video-animation__control')
		.removeClass('video-animation__control--focus');

	$container.trigger('update:remove-focus-state');
}

/**
 * Insert text animation
 * @param  {[object]} $field
 * @param  {[string]} text
 */
const insertTextAnimation = ($letter) => {
	const $nextLetter = $letter.next();

	$letter.addClass('video-animation__letter--added');

	if ($nextLetter.length > 0) {
		setTimeout(function() {
			insertTextAnimation($nextLetter);
		}, 50);
	} else {
		setTimeout(function() {
			$('.js-video-animations').trigger('update:text-insert');
		}, 1000);
	}
}

/**
 * Convert to rectangle
 *
 * @param  {Object} $container
 */
const convertToRectangle = ($container) => {
	$container.animate({
		'height': '250px'
	}, 500, 'linear', function() {
		$('.js-video-animations').trigger('update:covert-to-rectangle');
	});
}

/**
 * Convert to circle
 *
 * @param  {Object} $container
 */
const convertToCircle = ($container) => {
	$container.find('.video-animation__background').css('border-radius', '50%');

	$container.css('border-radius', '50%').animate({
		'height': '500px'
	}, 500, 'linear', function() {
		$('.js-video-animations').trigger('update:covert-to-circle');
	});
}

/**
 * Convert to square
 *
 * @param  {Object} $container
 */
const convertToSquare = ($container) => {
	$container.find('.video-animation__background').css('border-radius', '0');

	$container.css('border-radius', '0');

	setTimeout(function() {
		$('.js-video-animations').trigger('update:covert-to-square');
	}, 500);
}

/**
 * Reset animation and play again
 */
const resetAnimation = () => {
	const $container = $('.js-video-animations');

	$container.off('update:visible-logo-and-field')
		.off('update:actived-focus-state')
		.off('update:text-insert')
		.off('update:remove-focus-state')
		.off('update:covert-to-rectangle')
		.off('update:covert-to-circle')
		.off('update:covert-to-square')
		.off('update:hide-logo-and-field');

	handleVideoAnimation();
}

handleVideoAnimation();
